import { merge } from 'lodash-es';
import { view, lensPath, find } from 'ramda';
import { track, trackOn } from '@updater-core/lib/tracker';
import { selectors } from '../../../state';
import { STATES } from '../../../constants';
import './app';
import { BASE_PATH } from './app/constants';

export const NEW_LAYOUT_FEATURE_KEY = 'Promotions_New_Layout';

export function OffersConfig($stateProvider) {
  'ngInject';

  $stateProvider.state(STATES.STEP_PROMOTIONS, {
    url: `${BASE_PATH}/*path?wallet&ids&src`,
    disableBreadcrumb: true,
    data: {
      permissions: 'signedIn',
    },
    views: {
      '@': {
        template: '<upd-promotions></upd-promotions>',
        controller: (
          updEnvironment,
          updStore,
          $element,
          $scope,
          $stateParams
        ) => {
          const app = $element.find('upd-promotions')[0];
          const buildApp = buildMicroApp(
            app,
            $scope,
            updEnvironment,
            updStore,
            $stateParams.showSplashPage
          );
          buildApp().then(() => {
            const unsubscribe = updStore.subscribe(buildApp);
            $scope.$on('$destroy', unsubscribe);
          });
        },
      },
    },
    scrollTop: true,
    title: 'Exclusive Deals',
    analytics: {
      ignore: true,
    },
    params: {
      showSplashPage: false,
    },
    resolve: {
      guard: (appShell, updStore, $stateParams) => {
        return appShell.interactors.optimizely.actions
          .isFeatureEnabled('promotions_reskin')
          .then((enabled) => {
            if (!enabled) return;

            const showSplashPage = $stateParams.showSplashPage;
            const redirectPath = showSplashPage ? `/deals/splash` : `/deals`;

            updStore.dispatch({ type: 'HALT' });

            // Ensure existing experience doesnt flash by waiting for go and an extra second.
            return appShell.interactors.router
              .go(redirectPath)
              .then(() => new Promise((resolve) => setTimeout(resolve, 1000)));
          });
      },
    },
  });
}

function setupAnalytics(optimizely, app) {
  const generateEvent = (attributes) =>
    merge(
      {},
      {
        details: {
          source:
            app.shadowRoot && app.shadowRoot.querySelector('.splash-page')
              ? 'splash_page'
              : 'exclusive_offers',
          optimizely,
        },
        domain: 'promotions',
        page: {
          name: (() => {
            const {
              currentPath,
              config: { routes },
            } = app.router;
            const routeKey = find((val) => currentPath.match(new RegExp(val)))(
              Object.keys(routes).reverse()
            );
            const currentRoute = routes[routeKey];
            const name = view(
              lensPath(['data', 'analytics', 'event']),
              currentRoute
            );
            return name;
          })(),
        },
      },
      attributes
    );

  const trackOff = trackOn(app, generateEvent);

  const tracker = {
    track: (attributes) => track(generateEvent(attributes)),
  };

  return {
    trackOff,
    tracker,
  };
}

const buildMicroApp = (
  app,
  $scope,
  updEnvironment,
  updStore,
  showSplashPage
) => {
  return async function () {
    const updState = updStore.getState();
    const state = selectors.promotions.initialState(updState);

    if (!state.eligiblePromotions || !state.claimedPromotions || app.value) {
      return;
    }

    state.showSplashPage = showSplashPage;

    const optimizely = {
      experiments: {},
      features: {},
    };
    const dispatch = updStore.dispatch;

    const { tracker, trackOff } = setupAnalytics(optimizely, app);

    $scope.$on('$destroy', trackOff);

    app.value = {
      env: updEnvironment,
      tracker,
      optimizely,
      dispatch,
      ...state,
    };
    app.updStore = updStore;
  };
};
